import checkForDate from './checkForDate';
import { sort } from './sorting/sorter';
import { sortTypes } from './sorting/sort.types';
import { getCategoriesForChart } from './sorting/getChartCategories';
import { sorter } from './sorter';
import constants from '../highcharts/constants';

var isJsonString = function isJsonString(content) {
    try {
        JSON.parse(content);
    } catch (e) {
        return false;
    }

    return true;
};

var parseAndSortData = function parseAndSortData(normalizedSeries, widgetConfig, seriesDataObj) {
    var chartConfig = widgetConfig.ChartConfig,
        bubbleChartConfig = widgetConfig.BubbleChartConfig,
        gaugeConfig = widgetConfig.GaugeConfig,
        heatmapConfig = widgetConfig.HeatmapConfig,
        bulletConfig = widgetConfig.BulletConfig;


    for (var key in seriesDataObj) {
        if (typeof seriesDataObj[key] === 'string' && isJsonString(seriesDataObj[key])) seriesDataObj[key] = JSON.parse(seriesDataObj[key]);
    }

    if (!(chartConfig || bubbleChartConfig || gaugeConfig || bulletConfig) || !normalizedSeries) return seriesDataObj;

    var sortedData = {};

    if (bubbleChartConfig) {
        var InverseSort = bubbleChartConfig.InverseSort,
            AreaValueField = bubbleChartConfig.AreaValueField;

        var _sortedData = sorter.sortObjArrayByValue(seriesDataObj, InverseSort, AreaValueField);

        return {
            'Packed Bubble': _sortedData
        };
    } else if (gaugeConfig) {
        var _sortedData2 = sorter.sortObjArrayByValue(seriesDataObj);
        return {
            'Solid Gauge': _sortedData2
        };
    } else if (heatmapConfig) {
        var _sortedData3 = sorter.sortObjArrayByValue(seriesDataObj);
        return {
            Heatmap: _sortedData3
        };
    } else if (chartConfig && chartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL) {
        var _widgetConfig$ChartCo = widgetConfig.ChartConfig,
            _InverseSort = _widgetConfig$ChartCo.InverseSort,
            ValueField = _widgetConfig$ChartCo.ValueField;

        var _sortedData4 = sorter.sortObjArrayByValue(seriesDataObj, _InverseSort, ValueField);
        return {
            'Funnel Chart': _sortedData4
        };
    } else if (chartConfig && chartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID) {
        var _widgetConfig$ChartCo2 = widgetConfig.ChartConfig,
            _InverseSort2 = _widgetConfig$ChartCo2.InverseSort,
            _ValueField = _widgetConfig$ChartCo2.ValueField;

        var _sortedData5 = sorter.sortObjArrayByValue(seriesDataObj, _InverseSort2, _ValueField);
        return {
            'Pyramid Chart': _sortedData5
        };
    } else if (bulletConfig) {
        var Series = bulletConfig.Series,
            _InverseSort3 = bulletConfig.InverseSort,
            SortByValue = bulletConfig.SortByValue,
            SortByTarget = bulletConfig.SortByTarget;

        var result = [];
        var arr = [];

        if (!SortByValue && !SortByTarget) {
            if (_InverseSort3) {
                Object.keys(seriesDataObj).reverse().forEach(function (key) {
                    result.push(seriesDataObj[key]);
                });
            } else {
                for (var prop in seriesDataObj) {
                    result.push(seriesDataObj[prop]);
                }
            }
            return result;
        }

        if (Series[0].CategoryAxis) {
            var sortField = SortByValue ? Series[0].ActualValue : Series[0].TargetValue;
            for (var fieldName in seriesDataObj) {
                if (seriesDataObj.hasOwnProperty(fieldName)) {
                    var obj = {};
                    obj[fieldName] = seriesDataObj[fieldName];
                    obj.sortValue = seriesDataObj[fieldName][0][sortField];
                    arr.push(obj);
                }
            }
        } else {
            for (var series in Series) {
                var _sortField = SortByValue ? Series[series].ActualValue : Series[series].TargetValue;
                if (seriesDataObj.hasOwnProperty(Series[series].SeriesName)) {
                    var obj = {};
                    obj[Series[series].SeriesName] = seriesDataObj[Series[series].SeriesName];
                    obj.sortValue = seriesDataObj[Series[series].SeriesName][0][_sortField];
                    arr.push(obj);
                }
            }
        }
        arr = sorter.sortBySortOrder(arr, "sortValue", _InverseSort3);
        for (var i = 0, l = arr.length; i < l; i++) {
            delete arr[i].sortValue;
            for (var prop in arr[i]) {
                result.push(arr[i][prop]);
            }
        }
        return result;
    } else if (['pie', 'doughnut'].includes(chartConfig.ChartType.toLowerCase())) {
        seriesDataObj = { Pie: seriesDataObj };
    }

    var categories = getCategoriesForChart(chartConfig, seriesDataObj);

    if (chartConfig.DisplayCount) categories.splice(chartConfig.DisplayCount);

    var stacked = normalizedSeries.reduce(function (acc, series) {
        return acc || series.StackOnField;
    }, false);

    var grouped = normalizedSeries.reduce(function (acc, series) {
        return acc || series.GroupOnField;
    }, false);

    normalizedSeries.forEach(function (seriesConfig, i) {
        var ChartType = chartConfig.ChartType,
            Series = chartConfig.Series,
            SortAxis = chartConfig.SortAxis,
            XAxisField = chartConfig.XAxisField,
            YAxisFields = chartConfig.YAxisFields,
            InverseSort = chartConfig.InverseSort;
        var CrumbFieldName = seriesConfig.CrumbFieldName,
            FieldName = seriesConfig.FieldName,
            SeriesType = seriesConfig.SeriesType;


        var categoryField = ChartType.toLowerCase() === 'bar' ? YAxisFields[0] : XAxisField;
        var data = seriesDataObj[seriesConfig.SeriesName];

        var sortBySortOrder = seriesConfig.hasOwnProperty('OrderField');

        var sortType = void 0,
            field = void 0,
            categoryOrder = void 0;
        if (XAxisField && checkForDate(XAxisField)) {
            //handle dates
            sortType = sortTypes.DATE;
            field = XAxisField;
        } else if (sortBySortOrder) {
            sortType = sortTypes.SORT_ORDER;
            field = seriesConfig.OrderField;
        } else if (SortAxis) {
            sortType = sortTypes.CATEGORY;
            field = XAxisField;
        } else if (seriesConfig.StackOnField) {
            //handle stacked value sort
            sortType = sortTypes.SUM_OF_SERIES;
            field = FieldName;
        } else if (['scatterplot', 'bubble'].includes(seriesConfig.SeriesType.toLowerCase())) {
            sortType = sortTypes.VALUE;
            field = FieldName;
        } else if (i === 0) {
            sortType = sortTypes.VALUE;
            field = FieldName;
        }

        //data isn't  always present for each series config
        //ex: configurations by year (2017, 2018), but only data for the most recent year (2018)
        if (!data) return;

        if (categories && categories.length > 0) {
            if (SeriesType.toLowerCase() === 'line' || stacked || grouped) {
                categories.forEach(function (category) {
                    var _data$push;

                    var index = data.findIndex(function (d) {
                        return d[categoryField] === category;
                    });
                    if (index === -1) data.push((_data$push = {}, _data$push[categoryField] = category, _data$push[FieldName] = 0, _data$push));
                });
            }

            data = data.filter(function (d) {
                return d[categoryField] !== null && d[categoryField] !== '' && categories.findIndex(function (cat) {
                    return cat && d[categoryField] && cat.toString() === d[categoryField].toString();
                }) > -1;
            });
            data = sort(sortTypes.FIRST_SERIES, data, null, seriesDataObj, categoryField, categories);
        } else {
            data = data.filter(function (d) {
                return d[field] !== null;
            });
            data = sort(sortType, data, field, seriesDataObj, categoryField, categories);

            if (seriesConfig.SeriesType.toLowerCase() === 'scatterplot' || InverseSort) data.reverse();
        }

        sortedData[seriesConfig.SeriesName] = data;
    });

    return sortedData;
};

export default parseAndSortData;